<template>
	<div>
		<transition name="fade" mode="out-in">
			<component :is="currentComponent" :key="currentComponent"></component>
		</transition>
	</div>
</template>
<script>
export default {
	components: {
		detail1: () => import("./detail1.vue"),
		detail2: () => import("./detail2.vue"),
		detail3: () => import("./detail3.vue"),
	},
	data() {
		return {
			currentComponent: "",
		};
	},
	created() {
		this.handleDetail();
	},
	mounted() {},
	methods: {
		// 进入对应详情页
		handleDetail() {
			const repairType = sessionStorage.getItem("repairType") || this.$route.query.repairType;
			this.currentComponent = `detail${repairType}`;
		},
	},
};
</script>
<style lang="scss" scoped>
/* 淡入淡出效果 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

/* 滑动效果（可选） */
.slide-enter-active {
	transition: all 0.3s ease-out;
}
.slide-leave-active {
	transition: all 0.3s ease-in;
}
.slide-enter-from {
	opacity: 0;
	transform: translateX(30px);
}
.slide-leave-to {
	opacity: 0;
	transform: translateX(-30px);
}
</style>
